export const filterPickerStreamsById = (pickerStreams, id) => {
    if (pickerStreams && pickerStreams.length) {
        const contents = pickerStreams.map(streams => streams.contents);
        const streams = contents.filter(content => content.filter(stream => stream.id === id).length > 0)[0]; 
        if (streams && streams.length) {
            return streams.filter(stream => stream.id === id)[0];
        }
    }
    return null;
};


// WEBPACK FOOTER //
// ./app/lib/streamPicker/filterPickerStreamsById.js